import { render, staticRenderFns } from "./ShippingTable.vue?vue&type=template&id=0f3ed160&"
import script from "./ShippingTable.vue?vue&type=script&lang=ts&"
export * from "./ShippingTable.vue?vue&type=script&lang=ts&"
import style0 from "./ShippingTable.vue?vue&type=style&index=0&id=0f3ed160&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports